// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wy7j9","top":"styles_top__1HW8Z"};